var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcreteExpiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2589 0.518555L20.4232 4.68292L18.899 10.3723L13.2095 11.8966L9.04517 7.73226L10.5695 2.04283L16.2589 0.518555ZM7.49537 7.6268L3.76092 8.62744L1.02665 5.89336L2.02755 2.15844L5.76201 1.15779L8.49627 3.89188L7.49537 7.6268ZM0.662109 16.3542L4.82647 20.5186L10.5159 18.9943L12.0402 13.3049L7.87582 9.14054L2.18639 10.6648L0.662109 16.3542ZM13.59 13.4104L17.3244 12.4097L20.0587 15.1438L19.0578 18.8787L15.3233 19.8794L12.5891 17.1453L13.59 13.4104Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcreteExpiration);
export default __webpack_public_path__ + "static/media/concrete-expiration.65618b4dfbff3a070a5f1b0448c6d6b0.svg";
export { ForwardRef as ReactComponent };